import React, { FC } from 'react';

import { Outlet } from 'react-router-dom';

import { UnauthenticatedTemplate } from '@/modules/common';

const PublicPage: FC = () => {
  return (
    <UnauthenticatedTemplate>
      <Outlet />
    </UnauthenticatedTemplate>
  );
};
export default PublicPage;
